import { handleActions } from 'redux-actions';
import { APPROVE_PROSPECT_SUCCESS, CHECK_PROSPECT_SUCCESS, CALLBACK_PROSPECT_SUCCESS, CONVERT_PROSPECT_SUCCESS, DENY_PROSPECT_SUCCESS, GET_ALL_PROSPECTS_SUCCESS, UPDATE_PROSPECT_SUCCESS } from '../actions/actionTypes';

const initialState = {
  prospectsList: [],
  pagesQuantity: 0
}

export default handleActions(
  {
    [APPROVE_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [UPDATE_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [CHECK_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [CONVERT_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [CALLBACK_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [DENY_PROSPECT_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: state.prospectsList.map(
        p => (p.id === action.data.prospect.id ? action.data.prospect : p)
      )
    }),
    [GET_ALL_PROSPECTS_SUCCESS]: (state, action) => ({
      ...state,
      prospectsList: action.prospectsList,
      pagesQuantity: action.pagesQuantity
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/prospects.js